<template>
  <div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>故障管理</el-breadcrumb-item>
      <el-breadcrumb-item>已修复故障</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <!-- 添加用户 -->
      <el-row :gutter="20">
        <el-col :span="6">
          <el-input
            size="small"
            clearable
            placeholder="请输入搜索内容"
            v-model="queryInfo.query"
            @clear="getList">
            <el-button
              slot="append"
              @click="getList"
              icon="el-icon-search">
            </el-button>
          </el-input>
        </el-col>
      </el-row> 
      <!-- 表格 -->
      <el-row>
        <el-table :data="tableData" border stripe>
          <el-table-column 
            type="index" 
            align="center" 
            size="mini" 
            width="50">
          </el-table-column>
          <el-table-column
            align="center"
            v-for="(item, index) in waterCloumn"
            :key="index"
            size="mini"
            :prop="item.name"
            :min-width="item.minWidth"
            :label="item.label">
          </el-table-column>
        </el-table>
      </el-row>  
      <!-- 页码 -->
      <el-row>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryInfo.pagenum"
          :page-sizes="[2, 5, 10, 15]"
          :page-size="queryInfo.pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>      
      </el-row>   
    </el-card>

    <!-- 添加水表 -->
    <el-dialog
      title="新建水表"
      :visible.sync="waterMeterDialog"
      width="38%"
      @close="waterDialogClosed">
      <el-form
       :model="waterForm"
       :rules="waterFormRules"
       ref="waterFormRef"
       label-width="70px">
        <el-form-item label="SN" prop="sn">
          <el-input size="small" v-model="waterForm.sn"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="waterMeterDialog = false" size="small">取消</el-button>
        <el-button type="primary" @click="addWaterBtn" size="small">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import table from '@/mixins/tables'
export default {
  data () {
    return {
      waterMeterDialog: false,
      waterForm: {
        sn: ''
      },
      waterFormRules: {
        sn: [
          {
            required: true,
            message: '请输入Sn',
            trigger: 'blur'
          },
          {
            min: 2,
            max: 10,
            message: '用户名长度在 2 到 10 个字符之间',
            trigger: 'blur'
          }
        ]
      },  
      tableData: [ ],
      waterCloumn: [
        { name: 'name', label: '故障区域', minWidth: '160px' },
        { name: 'sn', label: 'SN', minWidth: '160px' },
        { name: 'typedesc', label: '故障类型', minWidth: '160px' },
        { name: 'founder', label: '申报人', minWidth: '160px' },
        { name: 'founderTime', label: '申报时间', minWidth: '160px' },
        { name: 'content', label: '备注', minWidth: '160px' },
        { name: 'startname', label: '操作人员', minWidth: '160px' },
        { name: 'starttime', label: '接收时间', minWidth: '160px' },  
        { name: 'endname', label: '完成人员', minWidth: '160px' },
        { name: 'endtime', label: '结束时间', minWidth: '160px' }   
      ],  
    }
  },
  mixins: [table],
  created () {
    this.getList()
  },
  methods: {
    getList() {
      var that = this;
      this.$post('/apis/manage/error/endErrorList',{
              page:that.queryInfo.pagenum-1,
              length:that.queryInfo.pagesize,
              token:sessionStorage.getItem('token'),
              name:that.queryInfo.query
          }).then(function(res){
            if(res.errno == 0){
              var data = res.data;
              var newList = [];
              for(var i=0;i<data.list.length;i++){
                newList.push({
                  id:data.list[i].id,
                  name:data.list[i].name,
                  typedesc:data.list[i].typeDesc,
                  sn:data.list[i].sn,
                  founder:data.list[i].createname,
                  founderTime:data.list[i].createtime,
                  starttime:data.list[i].starttime,
                  startname:data.list[i].startname,
                  endtime:data.list[i].endtime,
                  endname:data.list[i].endname,
                  content:data.list[i].content,
                })
              }
              that.tableData = newList;
              that.total = data.totalCount;
            }else if(res.errno == 99){
              that.$message.info(res.errmsg);
              sessionStorage.clear();
              that.$router.push("/login");
          }else{
            that.$message.info(res.errmsg);
          }
          }).catch(function(err){
            window.console.log(err);
          });
      /*
      console.log('获取数据了列表');
      this.tableData = [
        {id: 0, sn: '123456789', founder: ' 赵高',founderTime: '2019-12-15'},       
        {id: 1, sn: '69856', founder: ' 赵高',founderTime: '2019-12-15'},  
        {id: 2, sn: '996325', founder: ' 赵高',founderTime: '2019-12-15'},  
        {id: 3, sn: '511', founder: ' 赵高',founderTime: '2019-12-15'},  
        {id: 4, sn: '9965', founder: ' 赵高',founderTime: '2019-12-15'},  
      ]
      this.total = 1
      */
    },
    waterDialogClosed() {
      this.$refs.waterFormRef.resetFields()
    },
    addWaterBtn() {
      this.$refs.waterFormRef.validate( valid => {
        if (valid) {
          var that = this;
          this.$post('/apis/manage/meter/addMeter',{
              sn:this.waterForm.sn,
              token:sessionStorage.getItem('token'),
          }).then(function(res){
            if(res.errno == 0){
              console.log('确认添加水表');
              that.$message.success('新增水表成功');
              that.waterMeterDialog = false;
              that.getList();
            }else{
              that.$message.info(res.errmsg);
            }
          }).catch(function(err){
            window.console.log(err);
          });
        }
      }) 
    },
    editUser() {
      this.$refs.waterFormRef.validate( valid => {
        if (valid) {
          console.log('确认编辑sn');
          console.log(this.waterForm.sn);
          
          this.waterMeterDialog = false
        }
      }) 
    },
    removeUser(id) {
      var that = this;
      const confirmResult = this.$confirm(
        '此操作将结束故障检修流程，是否继续？',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'          
        }
      ).then(async () => { //  不要忘记加 async
              that.$post('/apis/manage/error/endError',{
                id:id,
                token:sessionStorage.getItem('token'),
              }).then(function(res){
                if(res.errno == 0){
                  that.$message.success('故障修复已结束');
                  that.getList();
                }else{
                  that.$message.info(res.errmsg);
                }
              }).catch(function(err){
                
              });
            
        }).catch(err => err)
    }
  }
}
</script>

<style>

</style>